import { Box, Flex, Icon, Text, desktopFirstMediaQuery } from '@inflearn/ds-react';
import { faBuildingCircleCheck } from '@inflearn/pro-regular-svg-icons/faBuildingCircleCheck';

import type { JobLevelDto } from '../../../../resources/@types/uccSchema';

type Props = {
  isActive: boolean;
  job?: string;
  jobLevel?: JobLevelDto;
  companyName?: string;
};

const HIDDEN_JOB_LEVEL = ['INTERN', 'BEGINNER', 'JUNIOR'];

export function MentoringInformation({ isActive, job, jobLevel, companyName }: Props) {
  const isNotHiddenJobLevel = jobLevel && !HIDDEN_JOB_LEVEL.includes(jobLevel.code);

  if (!isActive) {
    return null;
  }

  return (
    <Box
      w={'100%'}
      css={{
        [desktopFirstMediaQuery.tablet]: {
          marginTop: 0,
        },
      }}
    >
      <Flex justify={'center'}>
        {isNotHiddenJobLevel ? (
          <Text size="xs" weight={500} lineClamp={1} mr={5} color={'gray.6'}>
            {jobLevel?.name}
            <Text component="span" size="xs" ml={5} weight={500} color={'gray.6'}>
              ·
            </Text>
          </Text>
        ) : null}
        {job ? (
          <Text size="xs" weight={500} color="gray.6" lineClamp={1}>
            {job}
          </Text>
        ) : null}
      </Flex>
      {companyName ? (
        <Flex gap={2} align="center" justify={'center'}>
          <Icon icon={faBuildingCircleCheck} size="xs" color="infgreen.7" />
          <Text color="infgreen.7" lineClamp={1} weight={500} size="sm">
            {companyName}
          </Text>
        </Flex>
      ) : null}
    </Box>
  );
}
